import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { AdPartnerService } from '../../../services/AdPartner.service';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetSKANAdPartnersResponseActionPayload } from '../SKAdNetwork.types';

const GetSKANAdPartners = new ReduxAsyncAction<'GET_SKAN_AD_PARTNERS', void, GetSKANAdPartnersResponseActionPayload>(
  'GET_SKAN_AD_PARTNERS'
);

GetSKANAdPartners.registerRequest(async () => {
  const [appConfigsPayload, blueprintsPayload] = await Promise.all([
    dash_api.get(`/v1/ad-networks/app-skan`),
    dash_api.get(`/v1/ad-networks/global-skan`),
  ]);
  return {
    partners: AdPartnerService.mergeAppsWithBlueprints(appConfigsPayload.data, blueprintsPayload.data),
  };
});

export const GET_SKAN_AD_PARTNERS = GetSKANAdPartners.actionNamespaceConstants;

export const getSKANAdPartners = GetSKANAdPartners.request;

export type GetSKANAdPartnersResponseAction = Action<typeof GET_SKAN_AD_PARTNERS.response> & {
  data: GetSKANAdPartnersResponseActionPayload;
};
